import { useEffect } from "react";

import { cplEventsTracker } from "../../../shared/eventsTracker/events-tracker";
import { CplEventAction } from "../../../shared/eventsTracker/utils";
import { CplType, OptionType } from "../../widget.types";

import { QuestionButton } from "./question-button.component";

const allowTermsAndConditions =
  window.FKL.allowTermsAndConditions != undefined &&
  window.FKL.allowTermsAndConditions.toLocaleLowerCase() === "true";

export function QuestionCpl({
  isDisabled,
  isAccepted,
  brandName,
  emailReceiver,
  formPath,
  tacPath,
  title,
  onCplClick,
  name,
  bid,
}: CplType) {
  const CplTermsElement = ({
    formPath,
    tacPath,
  }: {
    formPath: string;
    tacPath: string;
  }) => {
    return allowTermsAndConditions && formPath && tacPath ? (
      <div className="quiz--single-page__body__question__cpl__terms">
        By accepting the offer, you will be opting into email marketing from{" "}
        {brandName}, and you agree to the&nbsp;
        <a
          href={tacPath}
          onClick={(event) => {
            event.preventDefault();
            window.open(tacPath!, "_blank");
          }}
        >
          Offer Terms &amp; Conditions
        </a>
      </div>
    ) : null;
  };

  const cplButtons: OptionType[] = [
    {
      id: "true",
      title: "Yes, email me the code",
      isCorrect: isAccepted === true,
      isSelected: isAccepted === true,
    },
    {
      id: "false",
      title: "No, thanks",
      isCorrect: isAccepted === true,
      isSelected: isAccepted === false,
    },
  ];

  useEffect(() => {
    cplEventsTracker({
      cplName: name,
      action: CplEventAction.IMPRESSION,
      value: bid,
      email: emailReceiver,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, bid]);

  return (
    <div className="quiz--single-page__body__question__cpl">
      <div className="quiz--single-page__body__question__cpl__message">
        {title}
      </div>
      <div className="quiz--single-page__body__question__cpl__receiver">
        Code will be sent to {emailReceiver}
      </div>
      <div
        className="quiz--single-page__body__question__cpl__options quiz__buttons"
        data-testid="quiz-question-cpl-options"
      >
        {cplButtons.map((option) => (
          <QuestionButton
            key={option.id}
            data-testid="quiz-question-option"
            data-option-id={option.id}
            isSelected={option.isSelected}
            isCorrect={option.isCorrect}
            isSms={false}
            isCpl={true}
            isReminder={false}
            isDisabled={isDisabled || false}
            onClick={() => onCplClick!(Boolean(JSON.parse(option.id)))}
          >
            {option.title}
          </QuestionButton>
        ))}
      </div>
      <CplTermsElement formPath={formPath!} tacPath={tacPath!} />
    </div>
  );
}
